import React from "react";
import FridgePageTemplate from "./FridgePageTemplate";

const relatedLinks = [
  { to: "/fridge-service-bangalore", label: "Refrigerator Service" },
  { to: "/fridge-not-cooling-repair", label: "Not Cooling Repair" },
  { to: "/fridge-compressor-repair", label: "Compressor Repair" },
  { to: "/double-door-refrigerator-service-bangalore", label: "Double Door Service" },
  { to: "/mini-fridge-service-bangalore", label: "Mini Fridge Service" },
];

const FridgeGasRefillService = () => {
  return (
    <FridgePageTemplate
      title="Fridge Gas Refill Service in Bangalore"
      description="Safe fridge gas refill service in Bangalore for refrigerators that need refrigerant top-up or leak repair."
      keywords="fridge gas refill bangalore, refrigerator gas charging service, fridge refrigerant refill"
      path="/fridge-gas-refill-service-bangalore"
      bannerTitle="Fridge Gas Refill Service"
      intro={
        <>
          Our Bangalore technicians provide <span style={{ fontWeight: "bold" }}>fridge gas refill service</span> with leak detection and safe refrigerant charging for better cooling performance.
        </>
      }
      highlights={[
        "Refrigerant leak detection",
        "Safe gas refill and charging",
        "Compressor and condenser inspection",
        "Cooling system performance checks",
      ]}
      issues={[
        "Cooling loss due to low refrigerant",
        "Frost build-up on evaporator",
        "Compressor short cycles",
        "Warm fridge despite running compressor",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default FridgeGasRefillService;

